<template>
  <div class="schedule">
    <div class="tpl-content" />
    <!-- 课程表模板维护 -->
    <schedule-tpl-dialog
      :course-id="courseId"
      :dialog-visible.sync="dialogTplVisible"
      :data="dateList"
      :get-chapter-item="activeEditItem"
      :chapter-list="chapterList"
      :chapter-ids="chapterIds"
      @confirm="getContentDetail"
      @close="closeTpl"
      @openItemDialog="openTplItemDialog"
      @activeItem="getChapterActiveItem"
      @addColumn="addColumn"
      @deletedItem="deletedItem"
      @moveColumn="moveColumn"
    />
    <!-- 课程表模板维护end -->
    <!-- 课程表模板章节维护 -->
    <schedule-tpl-item-dialog
      :chapter-list="chapterList"
      :dialog-visible.sync="tplItemDialogVisible"
      :item="activeEditItem"
      :chapter-ids="chapterIds"
      @confirm="getChapter"
    />
    <!-- 课程表模板章节维护 -->
    <!-- 课程表新增编辑 -->
    <scheduleDialog
      :dialog-visible.sync="dialogScheduleVisible"
      :course-id="courseId"
      :data="scheduleDialogInfo"
      @confirm="listDetailSchedule"
    />
    <!-- 课程表新增编辑 end-->
    <!-- 详情 -->
    <schedule-info
      :data="scheduleTplInfo"
      @openScheduleDialog="openScheduleDialog"
      @openTplDialog="openTplDialog"
      @confirm="listDetailSchedule"
      @goHistory="goHistory"
    />
    <schedule-info
      v-for="(schedule,index) in scheduleList.processing"
      :key="schedule.id"
      :data="schedule"
      :title="`课程表-正在进行${index+1}`"
      @deletedSchedule="deletedSchedule"
      @openScheduleDialog="openScheduleDialog"
    />
    <!-- 详情 -->
    <form-title>评价列表</form-title>
    <commentTable :course-id="courseId" />
  </div>
</template>
<script>
import axClient from '@/services';
import formTitle from '@/components/common/formTitle.vue';
import scheduleTplDialog from './dialog/scheduleTplDialog.vue';
import scheduleTplItemDialog from './dialog/scheduleTplItemDialog.vue';
import scheduleDialog from './dialog/scheduleDialog.vue';
import scheduleInfo from './scheduleInfo.vue';
import commentTable from './comment.vue';

export default {
  name: 'Schedule',
  components: {
    scheduleTplDialog,
    scheduleTplItemDialog,
    scheduleInfo,
    scheduleDialog,
    commentTable,
    formTitle,
  },
  props: {
    chapterList: {
      type: Array,
      default: () => [],
    },
    courseId: {
      type: Number,
    },
  },
  data() {
    return {
      result: {
        dateList: [],
      },
      dateList: [],
      scheduleTplInfo: {
        courseScheduleName: null, dateList: [],
      },
      scheduleDialogInfo: {},
      dialogTplVisible: false,
      dialogScheduleVisible: false,
      tplItemDialogVisible: false,
      editChapterItem: {},
      activeEditItem: {
        classContent: '',
        chapterList: [],
        totalMinute: null,
      },
      scheduleList: {},
    };
  },
  computed: {
    chapterIds() {
      const set = new Set();
      this.dateList.forEach((v) => {
        v.amContent.chapterList.forEach((chapter) => set.add(chapter.id));
        v.pmContent.chapterList.forEach((chapter) => set.add(chapter.id));
      });
      return Array.from(set);
    },
  },
  watch: {
    courseId() {
      this.getContentDetail();
      this.listDetailSchedule();
    },
    result() {
      this.dateList = this._.cloneDeep(this.result.dateList);
    },
    dateList() {
      this.scheduleTplInfo = { courseScheduleName: null, dateList: this.dateList };
    },
  },
  mounted() {
    this.getContentDetail();
    this.listDetailSchedule();
  },
  methods: {
    // 查看课程表历史
    goHistory() {
      localStorage.setItem('courseHistoryId', this.courseId);
      this.$router.push({
        name: 'ObsoleteList',
      });
    },
    // 查询课程表模板详情
    async getContentDetail() {
      if (!this.courseId) return;
      const data = await axClient.course.getContentDetail({ id: this.courseId });
      if (data.dateList) {
        const arr = [];
        data.dateList.forEach((v) => {
          const obj = {
            amContent: {
              classContent: v.amContent && v.amContent.classContent,
              totalMinute: v.amContent && v.amContent.totalMinute,
              recordVideoUrl: v.amContent ? v.amContent.recordVideoUrl : '',
              chapterList: v.amContent && v.amContent.chapterList
                ? v.amContent.chapterList.map((chapter) => ({ id: chapter.courseChapterId, chapterName: chapter.courseChapterName })) : [],
            },
            dateIndexId: v.dateIndexId,
            pmContent: {
              classContent: v.pmContent && v.pmContent.classContent,
              totalMinute: v.pmContent && v.pmContent.totalMinute,
              recordVideoUrl: v.pmContent ? v.pmContent.recordVideoUrl : '',
              chapterList: v.pmContent && v.pmContent.chapterList
                ? v.pmContent.chapterList.map((chapter) => ({ id: chapter.courseChapterId, chapterName: chapter.courseChapterName })) : [],
            },
          };
          arr.push(obj);
        });
        data.dateList = arr;
        this.result = data;
      } else {
        this.result.dateList = [];
      }
    },
    // 查询课程表列表
    async listDetailSchedule() {
      if (!this.courseId) return;
      const processing = await axClient.course.listDetailSchedule({ courseId: this.courseId, queryType: 10 });
      this.scheduleList = {
        processing,
      };
    },
    // 打开选择章节弹窗
    openTplItemDialog(item) {
      this.activeEditItem = item;
      this.tplItemDialogVisible = true;
    },
    getChapter(item) {
      this.activeEditItem = item;
      this.dateList[this.editChapterItem.index][this.editChapterItem.type] = { ...this.activeEditItem };
    },
    // 获取编辑的章节和简介
    getChapterActiveItem(item) {
      this.editChapterItem = item;
    },
    // 打开编辑课程表
    openTplDialog() {
      this.dialogTplVisible = true;
    },
    openScheduleDialog(item) {
      this.scheduleDialogInfo = item;
      this.dialogScheduleVisible = true;
    },
    // 删除课程表
    deletedSchedule(item) {
      this.$confirm('确定删除该课程表？', '删除该课程表', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.course.deleteSchedule({ id });
        if (data) {
          this.$message.success('删除成功');
          this.listDetailSchedule();
        }
      });
    },
    // 新增一行
    addColumn() {
      const obj = {
        amContent: {
          classContent: '',
          totalMinute: null,
          chapterList: [],
          recordVideoUrl: '',
        },
        pmContent: {
          classContent: '',
          totalMinute: null,
          chapterList: [],
          recordVideoUrl: '',
        },
      };
      this.dateList.push(obj);
    },
    // 移动课程表
    moveColumn(index, num) {
      // num 1 上移 -1 下移
      if (num === 1) {
        //
        if (index === 0) {
          this.$message.error('已经是第一个了');
          return;
        }
        // 在上一项插入该项
        this.dateList.splice(index - 1, 0, (this.dateList[index]));
        // 删除后一项
        this.dateList.splice(index + 1, 1);
      } else {
        // 下移
        if (index === (this.dateList.length - 1)) {
          this.$message.error('已经是最后一个了');
          return;
        }
        // 在下一项插入该项
        this.dateList.splice(index + 2, 0, (this.dateList[index]));
        // 删除前一项
        this.dateList.splice(index, 1);
      }
    },
    // 删除
    deletedItem(index) {
      this.dateList.splice(index, 1);
    },
    // 取消
    closeTpl() {
      this.dateList = this._.cloneDeep(this.result.dateList);
    },
  },
};
</script>
<style lang="scss" scoped>
.schedule {
  margin-top: 20px;
}
</style>
